import React, { useEffect, useState } from "react";
import { Button, Badge } from "react-bootstrap";
import { oneKlicks } from "../SDK/oneclick";
import { toast } from "react-toastify";

const HospitalPackages = () => {
    const [packages, setPackages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [viewMode, setViewMode] = useState("grid"); // "grid" or "list"

    useEffect(() => {
        fetchPackages();
    }, []);

    const fetchPackages = async () => {
        try {
            setLoading(true);
            const response = await oneKlicks.read("", "packages", {}, "id ASC", "", "", "");

            if (response?.success && response?.data) {
                setPackages(response.data);
            } else {
                toast.error("Failed to fetch packages");
                setPackages([]);
            }
        } catch (error) {
            console.error("Error fetching packages:", error);
            toast.error("Error loading packages");
            setPackages([]);
        } finally {
            setLoading(false);
        }
    };

    const renderFeatureValue = (value) => {
        if (value === "yes" || value === "Yes" || value === true) return "✓";
        if (value === "no" || value === "No" || value === false) return "✗";
        return value || "N/A";
    };

    const renderGridView = () => (
        <div className="row">
            {packages.map((pkg, idx) => {
                const isPopular = idx === 1;
                return (
                    <div key={pkg.id} className="col-12 col-md-6 col-lg-3 mb-4">
                        <div
                            className="card"
                            style={{
                                borderRadius: '8px',
                                border: isPopular ? '2px solid var(--themecolor)' : '1px solid #e8e8e8',
                                boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
                                position: 'relative',
                                transition: 'all 0.3s ease',
                                overflow: 'visible'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.1)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.06)';
                            }}
                        >
                            {isPopular && (
                                <div style={{
                                    position: 'absolute',
                                    top: '15px',
                                    right: '15px',
                                    background: '#00bcd4',
                                    color: '#fff',
                                    padding: '4px 12px',
                                    borderRadius: '12px',
                                    fontSize: '10px',
                                    fontWeight: '700',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    zIndex: 10
                                }}>
                                    POPULAR
                                </div>
                            )}

                            <div className="card-body text-center" style={{ padding: '40px 20px 30px' }}>
                                {/* Package Name */}
                                <h5 style={{
                                    fontSize: '18px',
                                    fontWeight: '700',
                                    color: '#333',
                                    marginBottom: '20px',
                                    marginTop: isPopular ? '20px' : '0'
                                }}>
                                    {pkg.name || "Package"}
                                </h5>

                                {/* Price */}
                                <div style={{ marginBottom: '25px' }}>
                                    <div className="d-flex align-items-start justify-content-center" style={{ marginBottom: '5px' }}>
                                        <span style={{
                                            fontSize: '24px',
                                            color: '#00bcd4',
                                            fontWeight: '700',
                                            marginTop: '8px'
                                        }}>₹</span>
                                        <span style={{
                                            fontSize: '48px',
                                            fontWeight: '700',
                                            color: '#00bcd4',
                                            lineHeight: '1',
                                            margin: '0 2px'
                                        }}>{pkg.price || 0}</span>
                                    </div>
                                    <span style={{
                                        fontSize: '13px',
                                        color: '#999',
                                        fontWeight: '500'
                                    }}>/{pkg.period || "Monthly"}</span>
                                </div>

                                {/* Features - Simplified */}
                                <div style={{
                                    textAlign: 'left',
                                    marginBottom: '25px',
                                    paddingTop: '20px',
                                    borderTop: '1px solid #f0f0f0'
                                }}>
                                    <ul className="list-unstyled mb-0" style={{ fontSize: '13px', color: '#666' }}>
                                        {pkg.autopost && (
                                            <li style={{ padding: '8px 0', display: 'flex', alignItems: 'center' }}>
                                                <i className="fa fa-check-circle" style={{ color: '#4caf50', marginRight: '10px', fontSize: '14px' }}></i>
                                                Auto Post
                                            </li>
                                        )}
                                        {pkg.chatsupport && (
                                            <li style={{ padding: '8px 0', display: 'flex', alignItems: 'center' }}>
                                                <i className="fa fa-check-circle" style={{ color: '#4caf50', marginRight: '10px', fontSize: '14px' }}></i>
                                                Chat Support
                                            </li>
                                        )}
                                        {pkg.featuredprofile && (
                                            <li style={{ padding: '8px 0', display: 'flex', alignItems: 'center' }}>
                                                <i className="fa fa-check-circle" style={{ color: '#4caf50', marginRight: '10px', fontSize: '14px' }}></i>
                                                Featured Profile
                                            </li>
                                        )}
                                        {pkg.profilewebsite && (
                                            <li style={{ padding: '8px 0', display: 'flex', alignItems: 'center' }}>
                                                <i className="fa fa-check-circle" style={{ color: '#4caf50', marginRight: '10px', fontSize: '14px' }}></i>
                                                Profile Website
                                            </li>
                                        )}
                                        <li style={{ padding: '8px 0', display: 'flex', alignItems: 'center' }}>
                                            <i className="fa fa-check-circle" style={{ color: '#4caf50', marginRight: '10px', fontSize: '14px' }}></i>
                                            Listing
                                        </li>
                                        <li style={{ padding: '8px 0', display: 'flex', alignItems: 'center' }}>
                                            <i className="fa fa-check-circle" style={{ color: '#4caf50', marginRight: '10px', fontSize: '14px' }}></i>
                                            Digital Card
                                        </li>
                                        <li style={{ padding: '8px 0', display: 'flex', alignItems: 'center' }}>
                                            <i className="fa fa-check-circle" style={{ color: '#4caf50', marginRight: '10px', fontSize: '14px' }}></i>
                                            Bookings
                                        </li>
                                    </ul>
                                </div>

                                {/* Button */}
                                <Button
                                    variant="primary"
                                    className="w-100"
                                    style={{
                                        background: 'var(--themecolor)',
                                        border: 'none',
                                        padding: '12px 20px',
                                        fontWeight: '600',
                                        fontSize: '14px',
                                        borderRadius: '6px',
                                        textTransform: 'capitalize'
                                    }}
                                >
                                    {pkg.name === "Free" ? "Get Started" : "Buy Now"}
                                </Button>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );

    const renderListView = () => (
        <div className="card">
            <div className="card-body">
                <div className="table-responsive">
                    <table className="table table-hover mb-0 align-middle">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Package Name</th>
                                <th>Price</th>
                                <th>Period</th>
                                <th>Features</th>
                                <th style={{ width: '180px' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {packages.map((pkg, idx) => {
                                const isPopular = idx === 1;
                                return (
                                    <tr key={pkg.id} style={{
                                        background: isPopular ? 'rgba(102, 126, 234, 0.05)' : 'transparent'
                                    }}>
                                        <td>#{pkg.id}</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <span className="font-weight-bold">{pkg.name || "Package"}</span>
                                                {isPopular && (
                                                    <Badge bg="primary" className="ms-2" style={{ fontSize: '10px' }}>POPULAR</Badge>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <span style={{ fontSize: '1.2rem', fontWeight: '700', color: 'var(--themecolor)' }}>
                                                ₹{pkg.price || 0}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="badge badge-info" style={{ padding: "5px 10px" }}>{pkg.period || "Monthly"}</span>
                                        </td>
                                        <td>
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                                {pkg.autopost && (
                                                    <span className="badge badge-secondary" style={{ fontSize: '11px', padding: "5px 10px" }}>
                                                        Auto Post: {renderFeatureValue(pkg.autopost)}
                                                    </span>
                                                )}
                                                {pkg.chatsupport && (
                                                    <span className="badge badge-secondary" style={{ fontSize: '11px', padding: "5px 10px" }}>
                                                        Chat: {renderFeatureValue(pkg.chatsupport)}
                                                    </span>
                                                )}
                                                {pkg.featuredprofile && (
                                                    <span className="badge badge-secondary" style={{ fontSize: '11px', padding: "5px 10px" }}>
                                                        Featured: {renderFeatureValue(pkg.featuredprofile)}
                                                    </span>
                                                )}
                                                {pkg.profilewebsite && (
                                                    <span className="badge badge-secondary" style={{ fontSize: '11px', padding: "5px 10px" }}>
                                                        Website: {renderFeatureValue(pkg.profilewebsite)}
                                                    </span>
                                                )}
                                                <span className="badge badge-success" style={{ fontSize: '11px', padding: "5px 10px" }}>Listing ✓</span>
                                                <span className="badge badge-success" style={{ fontSize: '11px', padding: "5px 10px" }}>Digital Card ✓</span>
                                                <span className="badge badge-success" style={{ fontSize: '11px', padding: "5px 10px" }}>Bookings ✓</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex" style={{ gap: 8 }}>
                                                <Button
                                                    size="sm"
                                                    variant="outline-secondary"
                                                    style={{ fontSize: '12px' }}
                                                >
                                                    View Details
                                                </Button>
                                                <Button
                                                    size="sm"
                                                    variant="primary"
                                                    style={{
                                                        fontSize: '12px',
                                                        background: 'var(--themecolor)',
                                                        border: 'none'
                                                    }}
                                                >
                                                    {pkg.name === "Free" ? "Get Started" : "Buy Now"}
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );

    if (loading) {
        return (
            <div className="dc-haslayout dc-dbsectionspace">
                <div className="container-fluid py-3">
                    <div className="card">
                        <div className="card-body text-center py-5">
                            <i className="fa fa-spinner fa-spin" style={{ fontSize: '2rem', color: 'var(--themecolor)' }}></i>
                            <h5 className="mt-3">Loading Packages...</h5>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2 mb-2">
                                <h5 className="mb-0 font-weight-bold mr-3">Hospital Packages</h5>
                                <Badge bg="info">Packages</Badge>
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                                <p className="mb-0 text-muted">Choose the perfect plan for your hospital</p>
                                <div className="d-flex gap-2">
                                    <Button
                                        variant={viewMode === 'grid' ? 'primary' : 'outline-primary'}
                                        onClick={() => setViewMode('grid')}
                                        style={{
                                            height: 50,
                                            background: viewMode === 'grid' ? 'var(--themecolor)' : 'transparent',
                                            borderColor: 'var(--themecolor)',
                                            color: viewMode === 'grid' ? '#fff' : 'var(--themecolor)'
                                        }}
                                    >
                                        <i className="ti-layout-grid2 me-1"></i> Grid View
                                    </Button>
                                    <Button
                                        variant={viewMode === 'list' ? 'primary' : 'outline-primary'}
                                        onClick={() => setViewMode('list')}
                                        style={{
                                            height: 50,
                                            background: viewMode === 'list' ? 'var(--themecolor)' : 'transparent',
                                            borderColor: 'var(--themecolor)',
                                            color: viewMode === 'list' ? '#fff' : 'var(--themecolor)'
                                        }}
                                    >
                                        <i className="ti-view-list me-1"></i> List View
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {packages.length === 0 ? (
                    <div className="card">
                        <div className="card-body text-center py-5">
                            <i className="ti-package" style={{ fontSize: '4rem', color: '#ccc' }}></i>
                            <p className="mt-3 text-muted">No packages available at the moment.</p>
                        </div>
                    </div>
                ) : (
                    viewMode === 'grid' ? renderGridView() : renderListView()
                )}
            </div>
        </div>
    );
};

export default HospitalPackages;
